import React, { memo } from "react";
import {
	Modal, ModalBody, ModalFooter,
	Button
} from "reactstrap";

const SaveAndExitPopup = memo( function SaveAndExitPopup({
	isOpen, handler, saveTestAndExit
}) {

	const toggle = () => {
		handler(prev => false);
	};

	const submitAndShowNext = () => {
		saveTestAndExit();
		toggle();
	};

	return (
		<Modal isOpen={isOpen} size="sm">
			<ModalBody>
				<div>Do you want to save and exit mock test?</div>
			</ModalBody>

			<ModalFooter>
				<Button
					color="secondary"
					className="modalCloseBtn"
					onClick={submitAndShowNext}
				>Yes</Button>
				
				<Button
					color="secondary"
					className="modalCloseBtn"
					onClick={toggle}
				>No</Button>
			</ModalFooter>
		</Modal>
	);
});

export default SaveAndExitPopup;